export default __webpack_public_path__ + "static/media/LoginLogo.80960e0d.png";